/* テキスト + 検索ボタン */
import React, { memo } from 'react';
import { FormControl, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
var TextWithSearch = function (_a) {
    var fm_id = _a.fm_id, id = _a.id, label = _a.label, need = _a.need, value = _a.value, handleChange = _a.handleChange, handleClick = _a.handleClick, handleBlur = _a.handleBlur, disabled = _a.disabled, message = _a.message, help_msg = _a.help_msg, maxlength = _a.maxlength;
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? (React.createElement(Paragraph, { label: value })) : (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 7 },
                    React.createElement(FormControl, { type: "text", id: id, onChange: handleChange, value: value, disabled: disabled, maxLength: maxlength, onBlur: handleBlur, "data-fm_id": fm_id })),
                React.createElement(Col, { xs: 4, className: "pr-0" },
                    React.createElement("button", { type: "button", className: "btn btn-outline-secondary", onClick: handleClick, disabled: disabled }, "\u691C\u7D22"))),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))) }));
};
export default memo(TextWithSearch);
